/**
 * Academy Visibility / Access — nur Master-Flag onboarding_academy_v1.
 * @param {(key: string) => boolean} hasFeature
 */
export function hasAcademyAccess(hasFeature) {
  if (typeof hasFeature !== "function") return false;
  return hasFeature("onboarding_academy_v1") === true;
}
